"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeGranularitySchema = void 0;
const zod_1 = require("zod");
exports.TimeGranularitySchema = zod_1.z.enum([
    // 'hour',
    'day',
    'week',
    'month',
    'quarter',
    'year',
]);
//# sourceMappingURL=granularitySchema.js.map